import apiClient from './apiClient';
import {
  DashboardStats,
  MembershipGrowthData,
  GymInfo,
  MembershipDistribution,
  VerificationRequest,
} from '../types/dashboard';

class DashboardService {
  /**
   * Fetch dashboard statistics
   */
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await apiClient.get('/dashboard/stats');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch dashboard stats:', error);
      throw error;
    }
  }

  /**
   * Fetch membership growth data for the last 8 weeks
   */
  async getMembershipGrowth(): Promise<MembershipGrowthData[]> {
    try {
      const response = await apiClient.get('/dashboard/membership-growth');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch membership growth:', error);
      throw error;
    }
  }

  /**
   * Fetch gym information
   */
  async getGymInfo(): Promise<GymInfo> {
    try {
      const response = await apiClient.get('/gyms/info');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch gym info:', error);
      throw error;
    }
  }

  /**
   * Fetch membership distribution (Pro vs Trial)
   */
  async getMembershipDistribution(): Promise<MembershipDistribution> {
    try {
      const response = await apiClient.get('/dashboard/membership-distribution');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch membership distribution:', error);
      throw error;
    }
  }

  /**
   * Fetch recent verification requests
   * @param limit - Number of requests to fetch (default: 5)
   */
  async getVerificationRequests(limit: number = 5): Promise<VerificationRequest[]> {
    try {
      const response = await apiClient.get(`/verifications/recent?limit=${limit}`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch verification requests:', error);
      throw error;
    }
  }

  
}

export const dashboardService = new DashboardService();
